import React from 'react';
import { Link } from 'react-router-dom';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { TcsmContentLink } from '../models/tcsm-block-models';
import { ExternalLink } from './external-link-modal';


interface Props {
    link: TcsmContentLink;
    text?: string;
}

export const TcsmContentLinkView = (props: Props) => {

    const { link, text } = props;

    const linkText = text || link?.linkText;
    const linkTextNode = (
        <>
            {linkText} {link?.addAsterisk && <span className='asterisk'>*</span>}
            {
                link?.isPdf &&
                <PictureAsPdfIcon />
            }
        </>

    );

    function RenderLink(){

        if (!link) return null;
        
        if (link.newWindow){
            return <Link to={link?.linkUrl} target="_blank" rel="noopener noreferrer">{linkTextNode}</Link>;
        }

        if (!link.reactLink){
            return <ExternalLink linkUrl={link?.linkUrl} linkText={linkTextNode} newWindow={link?.newWindow} />;
        }

        return <Link to={link?.linkUrl}>{linkTextNode}</Link>;
    }

    return (
        <>
        <RenderLink/>            
        </>
    );

};

TcsmContentLinkView.defaultProps = {
    text: '',
};


